import Box from "ds/components/Box";
import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import DraggableItem from "ds/components/DraggableItem";
import Typography from "ds/components/Typography";
import { useToggle } from "hooks/useToggle";

import styles from "./styles.module.css";

type NewStackSummaryHookProps = {
  name: string;
  after?: Array<{ text: string }>;
  before?: Array<{ text: string }>;
};

const NewStackSummaryHook = ({ name, after, before }: NewStackSummaryHookProps) => {
  const [isCollapsed, toggle] = useToggle(false);

  const count = (after?.length || 0) + (before?.length || 0);

  return (
    <CardCollapsible
      ariaLevel={2}
      ariaLabel={`${name}. ${count} elements.`}
      title={name}
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={count} />}
      contentGap="large"
    >
      {!!before?.length && (
        <Box direction="column" padding="large" gap="medium" className={styles.hooksWrapper}>
          <Typography tag="p" variant="p-t7" color="secondary">
            BEFORE
          </Typography>
          <Box direction="column" margin="medium 0 0 0">
            {before?.map(({ text }, index) => (
              <DraggableItem key={index} size="small" margin="0 0 medium 0" disabled>
                <Typography tag="p" variant="p-body3">
                  {text}
                </Typography>
              </DraggableItem>
            ))}
          </Box>
        </Box>
      )}
      {!!after?.length && (
        <Box direction="column" padding="large" gap="medium" className={styles.hooksWrapper}>
          <Typography tag="p" variant="p-t7" color="secondary">
            AFTER
          </Typography>
          <Box direction="column" margin="medium 0 0 0">
            {after?.map(({ text }, index) => (
              <DraggableItem key={index} size="small" margin="0 0 medium 0" disabled>
                <Typography tag="p" variant="p-body3">
                  {text}
                </Typography>
              </DraggableItem>
            ))}
          </Box>
        </Box>
      )}
    </CardCollapsible>
  );
};

export default NewStackSummaryHook;
